import PropTypes from 'prop-types';
import { useNavigate } from 'react-router-dom';

function BannerItem({ text, selected, href }) {
  const navigate = useNavigate();
  const onClick = (event) => {
    event.preventDefault();
    navigate(href);
  };
  return (
    <h1
      className={`banner-item ${selected ? 'selected' : 'unselected'}`}
      onClick={selected ? undefined : onClick}
    >
      {text}
    </h1>
  );
}

BannerItem.propTypes = {
  text: PropTypes.string.isRequired,
  selected: PropTypes.bool,
  href: PropTypes.string.isRequired
};

export default BannerItem;
